module.exports = __webpack_public_path__ + "img/Group 24059@2x.191db15c.png";